import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  paper: {
    backgroundColor: '#FFF',
    border: '1px solid #E5E5E5',
    boxSizing: 'border-box',
    borderRadius: '3px',
    width: '680px',
    maxWidth: '680px',
    height: '600px',
    overflow: 'hidden'
  },
  contentRoot: {
    overflowX: 'hidden',
    padding: '12px 30px',
    height: '451px',
    '&:first-child': {
      paddingTop: '3px'
    }
  },
  contentTextRoot: {
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 'normal',
    color: '#000',
    padding: '0',
    margin: '0'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '15px',
    fontWeight: '600',
    lineHeight: '18px',
    color: '#000',
    padding: '35px 30px 18px'
  },
  actionsRoot: {
    borderTop: '1px solid #E5E5E5',
    padding: '12px 30px'
  },
  cancelBtnRoot: {
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    color: '#0e8bb4',
    padding: '8px 15px',
    minWidth: '70px',
    marginRight: '7px'
  },
  actionBtnRoot: {
    boxShadow: 'none',
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    backgroundColor: '#0e8bb4',
    color: '#FFFFFF',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    padding: '8px 15px',
    minWidth: '70px',
    '&:hover': {
      backgroundColor: '#0e8bb4',
      color: '#FFFFFF'
    }
  },
  closeBtn: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '10px'
  },
  closeIcon: {
    fontSize: '17px',
    color: '#000'
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    '&:last-child': {
      marginBottom: 0
    }
  },
  infoIcon: {
    fontSize: '17px',
    marginRight: '15px'
  },
  listInfo: {
    marginBottom: '24px'
  },
  inputIndent: {
    marginBottom: '24px'
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: '15px'
  },
  smallSectionTitle: {
    fontWeight: 'bold',
    marginBottom: '7px'
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  participants: {
    marginBottom: '1px'
  },
  participantsErrorMsg: {
    margin: '-17px 0 23px'
  },
  radioGroupRoot: {
    flexDirection: 'column'
  },
  helpIcon: {
    fontSize: '18px',
    marginLeft: '6px'
  },
  addOnTitle: {
    fontSize: '13px'
  }
});
